import { checkCellValueStyle, NumericalCellValueStyle } from '@helpers';
import { useGetThemePerformance } from '@terminal/react-query-hooks/themes/useGetThemePerformance';
import { useMemo } from 'react';

interface ThemePerformanceDisplay {
  displayValue: number | undefined;
  formattedDate: string | undefined;
  numericalStyle: NumericalCellValueStyle;
}

export const useThemePerformanceDisplay = (
  themeId: string | undefined
): ThemePerformanceDisplay => {
  const listParams = themeId ? { ids: themeId } : undefined;

  const { themes } = useGetThemePerformance(listParams, !!themeId);
  const themeData = themes?.[0];

  const performance = themeData?.performance;
  const headlineHorizon = themeData?.intraday_metadata.headline_horizon;
  const displayValue =
    (headlineHorizon ? performance?.[headlineHorizon] : performance?.['1d']) ??
    undefined;

  const numericalStyle = checkCellValueStyle(displayValue);

  const formattedDate = useMemo(() => {
    const lastUpdated = themeData?.intraday_metadata?.last_updated;

    if (!lastUpdated) {
      return undefined;
    }

    try {
      return new Intl.DateTimeFormat(navigator.language, {
        day: 'numeric',
        month: 'short',
      }).format(new Date(lastUpdated));
    } catch {
      return undefined;
    }
  }, [themeData?.intraday_metadata?.last_updated]);

  return { displayValue, formattedDate, numericalStyle };
};
